<template>
  <div class="container">
    <h1>Textes</h1>
    <div class="bg-light border rounded p-4 mb-4">
      <p>
        Il est possible de modifier les textes de Quiz Boxing directement depuis
        cette interface.
      </p>
      <p>
        Le label indiqué en
        <span class="font-weight-bold text-primary">bleu</span> est le texte
        écrit dans l'application. Ce texte sera remplacé par le texte
        modifiable.
      </p>
      <p>
        Les champs se trouvant entre <code>{</code> et <code>}</code> sont des
        variables qui s'adaptent selon le contexte. Elles peuvent être utilisées
        dans les textes.<br />
        Exemple: <code>{username}</code> correspond au nom de l'utilisateur
        connecté.<br />
      </p>
      <p>
        Certains champs comportent du code HTML. Il est identifiable par le
        symbole <code>&lt;</code> et <code>&gt;</code>. Ce code est là pour
        mettre en forme le texte. Il est préférable de les laisser afin de
        garder la mise en forme de base.<br />
        Exemple: <code>&lt;strong&gt;TEXTE&lt;/strong&gt;</code> met le texte en
        gras.
      </p>
      <p>
        Il est possible de voir apparaitre des caractères de retour à la ligne
        dans les textes. Ils sont identifiables par le symbole
        <code>\n</code> ou <code>\r</code>.<br />
        Exemple: <code>\r</code> met un retour à la ligne.
      </p>
      <hr />
      <p>
        <span class="font-weight-bold"
          >N'oubliez pas de sauvegarder vos modifications une fois terminé
          !</span
        ><br />
        Une fois mis à jour, les salles téléchargeront automatiquement les
        nouveaux textes lors de leur redémarrage.
      </p>
    </div>

    <div class="locales-form-wrapper">
      <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
        <b-form-group
          v-for="(value, index) in contentFlat"
          :key="index"
          :id="index"
          :label="index"
          :label-for="index"
          label-size="lg"
        >
          <b-form-textarea
            id="input-horizontal"
            v-model="contentFlat[index]"
            rows="1"
            max-rows="5"
          ></b-form-textarea>
        </b-form-group>

        <div class="actions">
          <!-- <b-button type="reset" variant="danger">Réinitialiser</b-button> -->
          <b-button type="submit" variant="primary" size="md" class="ml-2 px-4">
            <b-icon-check></b-icon-check> Enregistrer
          </b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { BIconCheck } from 'bootstrap-vue'

  export default {
    name: 'Locales',
    components: {
      BIconCheck,
    },
    computed: {
      headers() {
        return {
          Authorization: 'Bearer ' + this.token,
        }
      },
    },
    mounted() {
      this.token = localStorage.getItem('jwt')
      if (!this.token) {
        this.$router.push('/login')
      }

      this.loadLocale()
    },
    data() {
      return {
        token: null,

        locale: 'fr',
        content: null,
        contentFlat: null,
      }
    },
    methods: {
      loadLocale() {
        axios
          .get('/locale/' + this.locale, {
            headers: this.headers,
          })
          .then((response) => {
            console.log(response.data)
            this.content = response.data
            this.contentFlat = this.flattenObject(response.data)
          })
          .catch((error) => {
            console.log(error)
          })
      },
      saveLocale() {
        let payload = {
          content: this.unflatObject(this.contentFlat),
        }
        axios
          .put('/locale/' + this.locale, payload, {
            headers: this.headers,
          })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Textes enregistrés',
              text: 'Les textes ont été mis à jour.',
            })
          })
          .catch((error) => {
            console.log(error)

            this.$notify({
              type: 'danger',
              title: 'Erreur',
              text: 'Une erreur est survenue lors de la mise à jour des textes.',
            })
          })
      },

      onSubmit() {
        console.log('onSubmit')
        console.log(this.contentFlat)
        console.log(this.unflatObject(this.contentFlat))

        this.saveLocale()
      },
      onReset() {
        console.log('onReset')
        console.log(this.content)
      },

      flattenObject(obj, parent, res = {}) {
        for (const key of Object.keys(obj)) {
          const propName = parent ? parent + '.' + key : key
          if (typeof obj[key] === 'object') {
            this.flattenObject(obj[key], propName, res)
          } else {
            res[propName] = obj[key]
          }
        }
        return res
      },

      unflatObject(obj = {}) {
        const result = {}
        let temp, substrings, property, i
        for (property in obj) {
          substrings = property.split('.')
          temp = result
          for (i = 0; i < substrings.length - 1; i++) {
            if (!(substrings[i] in temp)) {
              if (isFinite(substrings[i + 1])) {
                temp[substrings[i]] = []
              } else {
                temp[substrings[i]] = {}
              }
            }
            temp = temp[substrings[i]]
          }
          temp[substrings[substrings.length - 1]] = obj[property]
        }
        return result
      },
    },
  }
</script>

<style>
  .locales-form-wrapper form label {
    color: var(--blue);
    font-weight: bold;
  }

  .locales-form-wrapper .actions {
    position: fixed;
    bottom: 50px;
    right: 50px;
  }
</style>
